import { dictionary } from '@/constants/dictionary.js';
import _ from 'lodash';

export function isMobile() {
    let userAgentInfo = navigator.userAgent;
    if (userAgentInfo.indexOf("Windows") < 0 && userAgentInfo.indexOf("Mac OS") < 0) {
        return true;
    } else {
        return false;
    }
}

export function isValidPhone(str) {
    const reg = /^1[3-9]\d{9}$/;
    return reg.test(str);
}

export function isValidLoginName(str) {
    const reg = /^[0-9a-zA-Z_]+$/;
    return reg.test(str);
}

export function isValidEmail(str) {
    const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
    return reg.test(str);
}

export function isvalidlng(str) {
    const reg = /^[+-]?(0(\.\d{1,10})?|([1-9](\d)?)(\.\d{1,10})?|1[0-7]\d{1}(\.\d{1,10})?|180\.0{1,10})$/;
    return reg.test(str);
}

export function isvalidlat(str) {
    const reg = /^[+-]?((0|([1-8]\d?))(\.\d{1,10})?|90(\.0{1,10})?)$/;
    return reg.test(str);
}

/** 洛阳市中心坐标 [经度, 纬度]（GCJ-02） */
export const LUOYANG_CITY_CENTER = [112.45404, 34.61972];

/**
 * 判断是否为标准地图坐标
 * 支持 { longitude, latitude } / { lng, lat } / [lng, lat]
 * @param {Object|Array} coord
 * @returns {boolean}
 */
export function isValidMapCoordinate(coord) {
    if (coord == null || coord === '') {
        return false;
    }

    let lng;
    let lat;
    if (Array.isArray(coord)) {
        lng = coord[0];
        lat = coord[1];
    } else if (typeof coord === 'object') {
        lng = coord.longitude ?? coord.lng ?? coord.lon;
        lat = coord.latitude ?? coord.lat;
    } else {
        return false;
    }

    if (lng === '' || lng === null || lng === undefined ||
        lat === '' || lat === null || lat === undefined) {
        return false;
    }

    if (isvalidlng(String(lng)) && isvalidlat(String(lat))) {
        return true;
    }

    const lngNum = Number(lng);
    const latNum = Number(lat);
    return Number.isFinite(lngNum) && Number.isFinite(latNum)
        && lngNum >= -180 && lngNum <= 180
        && latNum >= -90 && latNum <= 90;
}


export function translate(key) {
    console.log(key);
    return dictionary[key] || key; // 如果字典中没有找到对应的汉字，则返回英文
}

export function delay(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function fixedFloat(value, fixed = 2) {
    if (_.isNumber(parseFloat(value)) && !_.isNaN(parseFloat(value))) {
        return parseFloat(value.toFixed(fixed));
    } else {
        return '---'
    }
}

/**
 * 前端通用分页函数
 * @param {Array} list 原始数组
 * @param {number} currentPage 当前页
 * @param {number} pageSize 每页条数
 * @returns {{list: Array, total: number}}
 */
export function paginateList(list = [], currentPage = 1, pageSize = 10) {
    const total = Array.isArray(list) ? list.length : 0;
    const safePageSize = pageSize > 0 ? pageSize : 10;
    const safeCurrentPage = currentPage > 0 ? currentPage : 1;
    const start = (safeCurrentPage - 1) * safePageSize;
    const end = start + safePageSize;
    return {
        list: (Array.isArray(list) ? list : []).slice(start, end),
        total
    };
}

/**
 * 前端通用模糊查询函数（可扩展字段）
 * @param {Array} list 原始数组
 * @param {string} keyword 关键字
 * @param {Array} fields 查询字段，可传字段名或自定义取值函数
 * @returns {Array}
 */
export function fuzzyFilterList(list = [], keyword = '', fields = []) {
    const safeList = Array.isArray(list) ? list : [];
    const safeKeyword = String(keyword || '').trim().toLowerCase();
    if (!safeKeyword) {
        return safeList;
    }
    const safeFields = Array.isArray(fields) ? fields : [];
    return safeList.filter(item => {
        return safeFields.some(field => {
            const value = typeof field === 'function' ? field(item) : item?.[field];
            if (value === null || value === undefined) {
                return false;
            }
            return String(value).toLowerCase().includes(safeKeyword);
        });
    });
}


